'use client';

import { useEffect, useRef } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

const datadogToken = 'puba1ad5273bdb658063531500b18b763f8';

async function initDatadog() {
  datadogLogs.init({
    env: 'production',
    site: 'datadoghq.com',
    service: 'medprev-web-app-frontend',
    clientToken: datadogToken,
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
  });

  datadogLogs.setGlobalContext({
    version: String(process.env.NEXT_PUBLIC_GIT_COMMIT_SHA),
  });
}

export default function Datadog() {
  const isInitialized = useRef<boolean>(false);
  useEffect(() => {
    if (isInitialized.current) {
      return;
    }
    isInitialized.current = true;

    initDatadog();
  });
  return null;
}
